module.exports = __webpack_public_path__ + "fonts/5885feb.ttf";